import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly TOKEN_KEY = 'authToken'
  private readonly TIMESTAMP_KEY = 'tokenTimestamp'
  private readonly EXPIRATION_TIME = 12 * 60 * 60 * 1000
  private readonly PERMISSIONS = 'permissions'
  private readonly INFOS = 'infos'
  private readonly baseUrl = environment.baseUrl

  constructor() {}

  saveToken(token: string): void {
    const currentTime = new Date().getTime()
    sessionStorage.setItem(this.TOKEN_KEY, token)
    sessionStorage.setItem(this.TIMESTAMP_KEY, currentTime.toString())
  }

  saveInfo(info: any): void {
    const infosJson = {
      id: info.id,
      name: info.nome,
      email: info.email,
      idPerfil: info.idPerfil,
      perfil: info.perfil,
      funcionarioId: info.funcionarioId,
      funcionarioFuncaoId: info.funcionarioFuncaoId,
      funcionarioFuncaoDescricao: info.funcionarioFuncaoDescricao,
      pessoaId: info.pessoaId,
      pessoaFisicaId: info.pessoaFisicaId,
    }

    sessionStorage.setItem(this.INFOS, JSON.stringify(infosJson))
  }

  getInfosObject(): any | null {
    const info = sessionStorage.getItem(this.INFOS)
    if (info) {
      return JSON.parse(info)
    } else {
      return null
    }
  }

  clearInfos(): void {
    sessionStorage.removeItem(this.INFOS)
  }

  getToken(): string | null {
    return sessionStorage.getItem(this.TOKEN_KEY)
  }

  isTokenValid(): boolean {
    const tokenTimestamp = sessionStorage.getItem(this.TIMESTAMP_KEY)
    if (tokenTimestamp) {
      const currentTime = new Date().getTime()
      const tokenAge = currentTime - parseInt(tokenTimestamp, 10)
      return tokenAge < this.EXPIRATION_TIME
    }
    return false
  }

  clearToken(): void {
    sessionStorage.removeItem(this.TOKEN_KEY)
    sessionStorage.removeItem(this.TIMESTAMP_KEY)
  }

  savePermissions(permissions: any[]): void {
    sessionStorage.setItem(this.PERMISSIONS, JSON.stringify(permissions))
  }

  getPermissions(): string | null {
    return sessionStorage.getItem(this.PERMISSIONS)
  }

  getPermissionsObject(): any | null {
    const permissions = sessionStorage.getItem(this.PERMISSIONS)
    if (permissions) {
      return JSON.parse(permissions)
    } else {
      return null
    }
  }

  checkPermission(permission: string, screen: string): boolean {
    const permissionsList = this.getPermissionsObject()
    for (let i = 0; i < permissionsList.length; i++) {
      const item = permissionsList[i]
      if (item.nomeTela.toLowerCase() == screen && item.nomeFuncao.toLowerCase() == permission) {
        return true
      }
    }
    return false
  }

  clearPermissions(): void {
    sessionStorage.removeItem(this.PERMISSIONS)
  }

  login(token: string): void {
    this.saveToken(token)
  }

  logout(): void {
    this.clearToken()
    this.clearPermissions()
    this.clearInfos()
  }

  validURl(): string {
    if (this.baseUrl.includes('api.tgmob-homolog.prolins.com.br')) {
      return 'homolog'
    } else if (this.baseUrl.includes('api.tgmob-dev.prolins.com.br')) {
      return 'development'
    } else if (this.baseUrl.includes('api.tgmob.preprod.prolins.com.br')) {
      return 'homolog'
    } else {
      return ''
    }
  }
}
